export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  {
    q: "什么是泡面番？",
    a: "泡面番指的是每集时长通常在三到五分钟左右的短篇动画，正好是泡一碗面的时间。因为短小精悍、节奏轻快，很适合在吃饭、通勤、摸鱼等碎片时间看，一口气就能看完好几集。",
  },
  {
    q: "小水看番的推荐都是真实看过的吗？",
    a: "是的。小水看番的每一部短番都经过团队逐集试看后才收录进清单，我们坚持『每一部都亲测』的原则，不注水、不凑数，只推荐真正好看、值得你花时间的下饭番和摸鱼短番。",
  },
  {
    q: "什么是『一口气看完』？",
    a: "『一口气看完』指的是总时长很短、可以一次性刷完的短番合集。我们在每部番的详情页都清楚标注了总集数和总时长，方便你提前规划，用两小时以内的完整时间体验一整季的快乐。",
  },
  {
    q: "下饭番和摸鱼短番有什么区别？",
    a: "下饭番偏节奏轻快、笑点密集的日常向，适合边吃边看；摸鱼短番则更强调短小精悍、随时能停，适合在工作学习间隙偷闲。两者都很短，只是适配的场景和心情略有不同。",
  },
  {
    q: "推荐的番在哪里可以看？",
    a: "我们提供的是客观、基于内容质量的短番推荐和评价，方便你按口味筛选。你可以根据榜单和详情页的内容介绍，前往你常用的正版视频平台搜索对应番名观看。",
  },
  {
    q: "可以投稿或推荐你喜欢的短番吗？",
    a: "当然可以！如果你发现了超棒的三分钟短番、下饭番或日常搞笑短篇，欢迎通过我们的联系邮箱投稿。小水团队试看后会认真考虑是否收录进榜单。",
  },
];